<template>
    <section class="p-5 card log-panel col-md-4 offset-md-4 col-10 offset-1 mt-md-0 mt-1">
        <h4 class="text-center mb-3">تقرير المركبات المغادرة وتجاوزت المدة القانونية دون العودة</h4>
        <div class="my-2" v-if="(getUser?.departId == 1)">
            <label for="departId" class="form-label">المركز الجمركي</label>
            <div class="d-flex">
                <select class="mx-1 form-select" id="departId" v-model="searchData['departId']" required="required">
                    <option value="" data-hidden="true" selected disabled>
                        اختر المركز الجمركي
                    </option>
                    <option v-for="depart in departs" :key="depart.id" :value="depart.id">
                        {{ depart.name }}
                    </option>
                </select>
            </div>
        </div>
            <div class="container justify-content-center my-2">
                <div class="form-check form-check-inline">
                    <input v-model="searchData.appType" class="form-check-input" type="radio" id="search-export" value="1" @change="resetValues()"/>
                    <label class="form-check-label" for="search-export">التصدير المؤقت</label>
                </div>
                <div class="form-check form-check-inline">
                    <input v-model="searchData.appType" class="form-check-input" type="radio" id="search-import" value="2" @change="resetValues()"/>
                    <label class="form-check-label" for="search-import">الاستيراد المؤقت</label>
                </div>
                <div class="form-check form-check-inline">
                    <input v-model="searchData.appType" class="form-check-input" type="radio" id="search-any" value="0" @change="resetValues()"/>
                    <label class="form-check-label" for="search-any">الكل</label>
                </div>
            </div>
            <button class="btn btn-secondary col-6 offset-6 my-1" type="button"  @click="getReport()">بحث</button>
    </section>

    <section v-if="reportData.length > 0" class="p-5 card log-panel col-xl-8 offset-xl-2 col-10 offset-1  my-3">
        <div class="row">
            <div v-for="(reportAppSection, index) in reportData" :key="index" class="table-responsive">
                <h2 class="text-center label">{{departs.find(e => e.id === reportAppSection.departId)?.name}}</h2>
                <table v-if="reportAppSection?.report.length" class="main-table table table-bordered">
                    <thead>
                        <tr>
                            <th>رقم التسجيل</th>
                            <th>اسم السائق</th>
                            <th>رقم الهاتف</th>
                            <th>رقم الجواز</th>
                            <th>نوع المركبة</th>
                            <th>طراز المركبة</th>
                            <th>رقم اللوحة</th>
                            <th>حالة الطلب</th>
                            <th>تاريخ المغادرة</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(applicant, i) in reportAppSection.report" :key="i" class="bg-blink">
                            <td>
                                <router-link class="nav-link" :to="'/admin/applicant/' + applicant.id">{{ applicant.id
                                    }}</router-link>
                            </td>
                            <td>
                                <router-link class="nav-link" :to="'/admin/applicant/' + applicant.id">{{
                                    applicant.applicantName }}</router-link>
                            </td>
                            <td>{{ applicant.phoneNo }}</td>
                            <td>{{ applicant.passNo }}</td>
                            <td>{{ applicant.transMade }}</td>
                            <td>{{ applicant.transModel }}</td>
                            <td>{{ applicant.plateNo }}</td>
                            <td :class="$adminAppStatus[applicant.appType][applicant.status]?.class">
                                {{ $adminAppStatus[applicant.appType][applicant.status]?.text }}
                            </td>
                            <td>{{ applicant.departDate }}</td>
                        </tr>
                    </tbody>
                </table>
                <div v-else class="text-center">
                    <h3>
                        <p class="text-muted">لا توجد نتائج مطابقة.</p>
                    </h3>
                </div>

                <!-- Pagination Controls for each table -->
                <div class="pagination-controls text-center mt-3">
                    <button class="btn btn-primary" :disabled="reportAppSection.pageNo === 1"
                        @click="changePage(reportAppSection, reportAppSection.pageNo - 1)">
                        السابق
                    </button>
                    <span class="mx-2">الصفحة {{ reportAppSection.pageNo }} من {{ reportAppSection.totalPages }}</span>
                    <button class="btn btn-primary" :disabled="reportAppSection.pageNo === reportAppSection.totalPages"
                        @click="changePage(reportAppSection, reportAppSection.pageNo + 1)">
                        التالي
                    </button>
                    <span class="mx-3" title="العدد الإجمالي">{{ (currentCountInView < reportData[0]?.totalResults) ? currentCountInView : reportData[0]?.totalResults }} من {{ reportData[0]?.totalResults }}</span>
                </div>

                <hr />
            </div>
        </div>
    </section>
</template>

<script>
import GeneralModal from "@/components/Modal.vue";
import AlertModal from "@/components/AlertModal.vue";
import { mapGetters, mapActions } from 'vuex';
export default {
    name: "illegalsReport",
    components: {
        GeneralModal,
        AlertModal
    },
    data() {
        return {
            searchData: {
                pageNo: 1,
                pageSize: 25,
                appType: 0,
            },
            departs: [],
            reportData: [],
        }
    },
    created() {
        const currentDate = new Date();
        //this.searchData.to = currentDate.toISOString().split('T')[0];
        this.fetchOptions();
    },
    computed: {
        ...mapGetters(['getUser', 'getDeparts']),
        currentCountInView : function(){
            return this.searchData?.pageSize * this.searchData?.pageNo;
        }
    },
    methods: {
        /** */
        ...mapActions([
            'fetchUser',
            'fetchDeparts'
        ]),
        /********************************/
        /* */
        async fetchOptions() {
            if (this.getDeparts.length == 0) {
                await this.fetchDeparts();
            }
            if (this.getUser.hasOwnProperty("empNo") == 0) {
                await this.fetchUser();
            }
            this.departs = (this.getDeparts[0].id == 1) ? this.getDeparts.slice(1) : this.getDeparts;
        },
        /********************/

        // Fetch the report data with pagination for each section
        async getReport() {
            this.searchData.pageNo = 1;
            try {
                const response = await this.$axios.post(`api/employee/report/getillegalapplicants`, this.searchData);

                if (response?.data && response?.data.isSuccess) {
                    // Update the reportData with pagination information for each section
                    this.reportData = [response.data.data];
                } else {
                    this.$tempAlert(response?.data.msg ?? "حدثت مشكلة", 'warning');
                    this.reportData = [];
                }
            } catch (error) {
                console.error("Error fetching report:", error);
                if (error.response?.data) {
                    this.$tempAlert(error.response.data.msg, 'warning');
                }
            }
        },

        // Change the current page for a specific report section
        changePage(reportAppSection, newPageNo) {
            if (newPageNo >= 1 && newPageNo <= reportAppSection.totalPages) {
                reportAppSection.pageNo = newPageNo;
                this.getReportForSection(reportAppSection);
            }
        },

        /********************/
        // Fetch the report for a specific section based on the page number
        async getReportForSection(reportAppSection) {
            this.searchData.pageNo = reportAppSection.pageNo
            try {
                const response = await this.$axios.post(`api/employee/report/getillegalapplicants`, this.searchData);
                this.reportData = [response.data.data];
            } catch (error) {
                console.error("Error fetching report for section:", error);
            }
        },
        /********************/
        /* */
        resetValues() {
            this.reportData=[];
            this.searchData.pageNo = 1;
        },
        /********************/
    }
}
</script>
